import { createLucideIcon } from "lucide-react";

export const Plug = createLucideIcon(
    "Plug",
    [
        [
            "path",
            {
                d: "M11 9H13",
                key: "2yls78",
            },
        ],
        [
            "path",
            {
                d: "M12 17V22",
                key: "1kpoh6",
            },
        ],
        [
            "path",
            {
                d: "M15.5 2V6",
                key: "xp5rne",
            },
        ],
        [
            "path",
            {
                d: "M6.00446 7.61331C5.93719 6.74273 6.63957 6 7.53014 6H16.4699C17.3604 6 18.0628 6.74273 17.9955 7.61331L17.8117 9.99197C17.6796 11.7019 17.1011 13.3498 16.132 14.7773L15.5312 15.6622C14.9638 16.4979 14.0077 17 12.9838 17H11.0162C9.99228 17 9.03617 16.4979 8.46881 15.6622L7.86803 14.7773C6.89885 13.3498 6.32041 11.7019 6.18827 9.99197L6.00446 7.61331Z",
                key: "1l5edo",
            },
        ],
        [
            "path",
            {
                d: "M8.5 6V2",
                key: "wgdcfa",
            },
        ],
    ],
);
